import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useGlobalContext } from "../../../Config.js";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import FormCrearComboProductos from "../components/FormCrearComboProductos.js";
import FormCrearProducto from "../components/FormCrearProducto.js";
import FormEditarProducto from "../components/FormEditarProducto.js";
import TableProductos from "../components/TableProductos.js";
import FormCrearProductoSubproducto from "../components/FormCrearProductoSubproducto.js";
import Loader from "../../../shared/ui/Loader.js";
import { Toast } from 'primereact/toast';
import { ProductService } from "../../../services/ProductService.js";
import useEmpresas from "../hooks/useEmpresas.js";
import useProductos from "../hooks/useProductos.js";
import useTiposProducto from "../hooks/useTiposProducto.js";
import { limpiarRut, esRutLimpioValido, formatearRut } from "../utils/medidoresHelpers.js";
import {
  tieneCaracteresInvalidos,
  esMetrajeValido,
  existeProductoDuplicado,
} from "../utils/productoValidations.js";
import { validarDescripcion } from "../../../utilities/textValidations.js";

const productService = new ProductService();

const MantenedorProductos = () => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [displayDialog, setDisplayDialog] = useState(false);
  const [displayDialogCombinatoria, setDisplayDialogCombinatoria] = useState(false);
  const [displayDialogProductoSubproducto, setDisplayDialogProductoSubproducto] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [id, setId] = useState("");
  const [metraje, setMetraje] = useState("");
  const [idTipo, setIdTipo] = useState("");
  const [union, setUnion] = useState("");
  const [adyacentes, setAdyacentes] = useState([]);
  const { baseUrl, urlMedidores, headerText } = useGlobalContext();
  const fichaRef = useRef(null);
  const [productoCombinado, setProductoCombinado] = useState({
      tipoProducto: "",
      productos: [],
      descripcionCombinada: "",
      metraje: ""
    });
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const idUsuario = sessionStorage.getItem("usuario_id");

  const { empresa, setEmpresa, listaEmpresas, nombreEmpresa } = useEmpresas(baseUrl);
  const { productos, setProductos, loadingInicial, fetchData } = useProductos(
    baseUrl,
    empresa,
    nombreEmpresa
  );
  const { tipoProductoOptions, fetchTipoProductoByEmpresa } = useTiposProducto(
    baseUrl,
    empresa,
    nombreEmpresa
  );

  const [producto, setProducto] = useState({
    descripcion: "",
    metraje: "",
    tipoProducto: "",
  });

  const handleSaveProducto = async () => {
    // GUARD: descripcion obligatoria y largo maximo 45 (sin cambios si falla)
    const errorDescripcion = validarDescripcion(descripcion);
    if (errorDescripcion) {
      alert(errorDescripcion);
      return;
    }
    try {
      setLoading(true);
      const updatedProduct = {
        ...selectedProduct,
        idTipo: producto.idTipo ?? idTipo,
        descripcion,
        metraje,
      };
      await productService.updateProducto(baseUrl, updatedProduct, headerText);

      // Si existen productos vecino crear pasando el array del productos adyacentes del form y id del nuevo producto
      if (adyacentes && adyacentes.length > 0) {
        const productosAdyacentes = {
          idProducto: updatedProduct.id,
          productos: adyacentes.map(prod => prod.id),
        };
        await productService.updateProductoAdyacente(baseUrl, productosAdyacentes, headerText);
      } else {
        await productService.desactivarProductoAdyacente(baseUrl, updatedProduct.id, headerText);
      }

       // Actualizar la ficha del producto si existe fichaRef
      if (fichaRef && fichaRef.current) {
        const fichaData = fichaRef.current.getData();
        await productService.updateProductoFicha(baseUrl, {
          idProducto: updatedProduct.id,
          perfil: fichaData.perfil,
          ficha: fichaData.fichaJson
        });
      }

      setProducto({ descripcion: "", metraje: "", tipoProducto: "", remarcadores: [] });
      setShowEditDialog(false);
      fetchData();
      toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Producto actualizado exitosamente.', life: 3000 });
    } catch (error) {
      console.error("Error al actualizar el producto:", error);
      toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al actualizar el producto", life: 3000 });
    }

  };

  const handleEditProducto = (producto) => {
    setSelectedProduct(producto);
    setDescripcion(producto.descripcion);
    setId(producto.id);
    setMetraje(producto.metraje);
    setIdTipo(producto.idTipo);
    setUnion(producto.combo.combinado);
    setProducto({ descripcion: "", metraje: "", tipoProducto: "" });
    // Validación más robusta para productos adyacentes
    let adyacentesArray = [];
    if (producto.adyacentes) {
      if (Array.isArray(producto.adyacentes)) {
        adyacentesArray = producto.adyacentes;
      } else if (producto.adyacentes.lista && Array.isArray(producto.adyacentes.lista)) {
        adyacentesArray = producto.adyacentes.lista;
      }
    }
    setAdyacentes(adyacentesArray);
    setShowEditDialog(true);
  };

  const validateInputs = () => {
    if (!producto.descripcion || !producto.metraje || !producto.tipoProducto) {
      alert("Todos los campos son obligatorios.");
      return false;
    }
    if (tieneCaracteresInvalidos(producto.descripcion)) {
      alert("La descripción no debe contener caracteres especiales");
      return false;
    }
    // GUARD: descripcion obligatoria y largo maximo 45
    const errorDescripcion = validarDescripcion(producto.descripcion);
    if (errorDescripcion) {
      alert(errorDescripcion);
      return false;
    }
    if (!esMetrajeValido(producto.metraje)) {
      alert("El metraje debe ser un número mayor a 0.");
      return false;
    }

    // Validación: no permitir crear productos con misma descripción y tipo
    const existeDuplicado = existeProductoDuplicado(
      productos,
      producto.descripcion,
      producto.tipoProducto
    );

    if (existeDuplicado) {
      alert("Ya existe un producto con esa descripción y tipo.");
      setLoading(false);
      return;
    }

    return true;
  };

  const checkMedidoresService = async () => {
    try {
      return await productService.checkServicioMedidores(urlMedidores);
    } catch (error) {
      alert(error.message || "No fue posible validar el servicio de medidores");
      return false;
    }
  };

  //ORQUESTADOR DE CREAR PRODUCTO (bodegas + medidores)
  const crearProductoConRemarcadores = async ({
    empresa: empresaNombre,
    idEmpresa,
    descripcion,
    metraje,
    idTipoProducto,
    remarcadores = []
  }) => {
    //CREA PRODUCTO EN BODEGAS
    const data = await productService.createProducto(
      baseUrl,
      { empresa: empresaNombre, descripcion, metraje, idTipoProducto, idUsuario },
      headerText
    );

    const insertedProducto = data.producto;
    const fechaInstalacion = new Date().toISOString().split("T")[0];

    const empresaData = await productService.getEmpresaById(baseUrl, idEmpresa);
    const rutEmpresaRaw = empresaData?.rut;

    if (!rutEmpresaRaw) {
      throw new Error("No se pudo obtener rutEmpresa desde getEmpresaById");
    }

    const rutEmpresaLimpio = limpiarRut(rutEmpresaRaw);

    if (!esRutLimpioValido(rutEmpresaLimpio)) {
      throw new Error("rutEmpresa inválido");
    }

    const rutEmpresa = formatearRut(rutEmpresaLimpio);

    const remarcadoresPayload = remarcadores.map((remarcador) => ({
      codigo: remarcador.codigo || insertedProducto.codigo,
      qrCode:
        remarcador.qrCode !== null && remarcador.qrCode !== undefined
          ? remarcador.qrCode
          : null,
      proveedorId: remarcador.proveedorId,
      tipoId: remarcador.tipoRemarcadorId,
      unidadMedidaId:
        remarcador.unidadMedidaId ?? remarcador.tipoRemarcadorId ?? null,
      marca: remarcador.marca || "SIN DATOS",
      caracteristica:
        remarcador.caracteristica ||
        `REMARCADOR ${String(remarcador.tipoRemarcador || "SIN DATOS").toUpperCase()}`,
      contrato: remarcador.contrato ?? null,
      ruta: remarcador.ruta ?? null,
      ubicacion: remarcador.ubicacion ?? null,
      ubicacionDetalle: remarcador.ubicacionDetalle ?? null,
      fechaInstalacion: remarcador.fechaInstalacion || fechaInstalacion,
      lecturaInicial: remarcador.lecturaInicial ?? 0,
      activo: remarcador.activo ?? true,
    }));

    const insertarDomicilioBody = {
      domicilio: {
        codigo: insertedProducto.codigo,
        descripcion: insertedProducto.descripcion,
        direccion: "Sin Dirección",
      },
      rutEmpresa,
      rutCliente: null,
      crearRemarcadores: remarcadoresPayload.length > 0,
      remarcadores: remarcadoresPayload,
    };

    //CREA DOMICILIO EN MEDIDORES
    try {
      await productService.insertarDomicilio(urlMedidores, insertarDomicilioBody);
    } catch (error) {
      setDisplayDialog(false);
      throw error;
    }

    return data;
  };

  //ORQUESTADOR DE CREAR PRODUCTO
  const handleCreateProducto = async () => {
    if (!validateInputs()) {
      return;
    }
    try{
      setLoading(true);
      setLoading3(true);

      //VALIDA SERVICIO MEDIDORES ACTIVO
      const medidoresDisponible = await checkMedidoresService();
      if (!medidoresDisponible) {
        return null;
      }

      //crear producto en bodegas y medidores
      const newProducto = {
        empresa: nombreEmpresa,
        idEmpresa: empresa,
        descripcion: producto.descripcion,
        metraje: producto.metraje,
        idTipoProducto: producto.tipoProducto.id,
        remarcadores: producto.remarcadores || [],
      };

      // Esperar el resultado y obtener el ID del producto creado
      const resultadoCreacion = await crearProductoConRemarcadores(newProducto);
      const idProductoCreado = resultadoCreacion.producto.id;

      //si existen productos vecino crear pasando el array del productos adyacentes del form y id del nuevo producto
      if (producto.productosAdyacentes && producto.productosAdyacentes.length > 0) {
        const productosAdyacentes = {
          idProducto: idProductoCreado,
          productos: producto.productosAdyacentes.map(prod => prod.id),
        };

        await productService.createProductoAdyacente(baseUrl, productosAdyacentes, headerText);
      }

      setProducto({ descripcion: "", metraje: "", tipoProducto: "" });
      toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Producto creado exitosamente.', life: 3000 });
      return resultadoCreacion;
    }catch (error) {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear producto", life: 3000 });
      return null;
    }finally{
      fetchData();
      setLoading(false);
      setLoading3(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      await productService.getReporteProductos(baseUrl);
      toast.current?.show({
        severity: "success",
        summary: "Exportación exitosa",
        detail: "Se descargó el archivo reporte_productos.xlsx",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "No se pudo exportar el archivo Excel.",
        life: 3000,
      });
    } finally {
      setExporting(false);
    }
  };

  const handleDeleteUnionProducto = () => {
    // Validación
    if (!selectedProduct?.id) {
      alert("Selecciona un producto válido para desactivar la unión.");
      return;
    }

    confirmDialog({
      message: "¿Estás seguro de que deseas desactivar esta union de productos?",
      header: "Confirmar Desactivación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: async () => {
        try {
          // Llamada al servicio con el id
          await productService.deleteUnionProducto(baseUrl, selectedProduct.id);
        } catch (error) {
          console.error("Error al desactivar el producto:", error);
          alert(`Error: ${error.message}`);
        } finally {
          setShowEditDialog(false);
          alert("Producto desactivado exitosamente.");
          await fetchData();
        }
      },
    });
  };


  useEffect(() => {
    if (empresa) {
      setGlobalFilterValue('');
      fetchData();
      fetchTipoProductoByEmpresa(empresa);
    }
  }, [empresa, baseUrl]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
        <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={(e) => {
              const upperCaseValue = e.target.value.toUpperCase();
              onGlobalFilterChange({ target: { value: upperCaseValue } });
            }}
            placeholder="Buscar por Descripción"
          />
        </span>
        <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
          {productos?.length} productos {nombreEmpresa}
        </span>
      </div>
    );
  };
  const header = renderHeader();

  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Gestión de Productos</h4>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="empresa"
              value={empresa}
              onChange={(e) => setEmpresa(e.value)}
              options={listaEmpresas}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Empresa"
              className="p-inputtext-sm"
              style={{ borderRadius: "4px" }}
            />
          </div>
        </div>
      </div>
      {empresa && (
        <>
          <div className="col-12">
            <div className="card">
              <>
                {loadingInicial ? (
                  <>
                    <Loader />
                  </>
                ) : (
                  <>
                    <Button
                      label="Crear Producto"
                      icon="pi pi-plus"
                      className="p-button p-component mr-2 p-button-rounded p-button-primary mt-3"
                      onClick={() => setDisplayDialog(true)}
                      disabled={loadingInicial}
                      raised
                    />
                    <Button
                      label="Asociar Subproducto"
                      icon="pi pi-fw pi-tags"
                      className="p-button p-component mr-2 p-button-rounded p-button-info mt-3"
                      onClick={() => setDisplayDialogProductoSubproducto(true)}
                      disabled={loadingInicial}
                      raised
                    />
                    <Button
                      label="Unir Productos"
                      icon="pi pi-link"
                      className="p-button p-component mr-2 p-button-rounded p-button-help mt-3"
                      onClick={() => setDisplayDialogCombinatoria(true)}
                      disabled={loadingInicial}
                      raised
                    />
                    <Button
                      label="Exportar Excel"
                      icon="pi pi-file-excel"
                      className="p-button p-component mr-2 p-button-rounded p-button-success mt-3"
                      onClick={handleExportExcel}
                      loading={exporting}
                      disabled={loadingInicial}
                      raised
                    />

                    <TableProductos
                      header={header}
                      productos={productos}
                      loading={loadingInicial}
                      globalFilterValue={globalFilterValue}
                      tipoProductoOptions={tipoProductoOptions}
                      handleEditProducto={handleEditProducto}
                      nombreEmpresa={nombreEmpresa}
                      className="mt-3"
                    />

                    <FormCrearProducto
                      displayDialog={displayDialog}
                      setDisplayDialog={setDisplayDialog}
                      producto={producto}
                      setProducto={setProducto}
                      tipoProductoOptions={tipoProductoOptions}
                      handleCreateProducto={handleCreateProducto}
                      baseUrl={baseUrl}
                      urlMedidores={urlMedidores}
                      empresa={empresa}
                      nombreEmpresa={nombreEmpresa}
                      loading3={loading3}
                    />

                    <FormEditarProducto
                      showEditDialog = {showEditDialog}
                      setShowEditDialog = {setShowEditDialog}
                      descripcion = {descripcion}
                      idTipo = {idTipo}
                      union = {union}
                      id = {id}
                      setDescripcion = {setDescripcion}
                      metraje = {metraje}
                      setMetraje = {setMetraje}
                      adyacentes = {adyacentes}
                      setAdyacentes = {setAdyacentes}
                      productos = {productos}
                      loading = {loadingInicial}
                      handleSaveProducto = {handleSaveProducto}
                      selectedProduct = {selectedProduct}
                      fichaRef = {fichaRef}
                      producto={producto}
                      setProducto={setProducto}
                      tipoProductoOptions={tipoProductoOptions}
                      handleDeleteUnionProducto={handleDeleteUnionProducto}
                    />

                    <FormCrearComboProductos
                      empresa={empresa}
                      listaEmpresas={listaEmpresas}
                      loading={loadingInicial}
                      setLoading={setLoading}
                      baseUrl={baseUrl}
                      nombreEmpresa={nombreEmpresa}
                      setProductos={setProductos}
                      productoCombinado={productoCombinado}
                      setProductoCombinado={setProductoCombinado}
                      setProductosFiltrados={setProductosFiltrados}
                      displayDialogCombinatoria={displayDialogCombinatoria}
                      setDisplayDialogCombinatoria={setDisplayDialogCombinatoria}
                      productosFiltrados={productosFiltrados}
                      fetchDataProductos={fetchData}
                      toast={toast}
                    />

                    <FormCrearProductoSubproducto
                      empresa={empresa}
                      listaEmpresas={listaEmpresas}
                      loading={loading}
                      setLoading={setLoading}
                      baseUrl={baseUrl}
                      nombreEmpresa={nombreEmpresa}
                      productos={productos}
                      setProductos={setProductos}
                      displayDialogProductoSubproducto={displayDialogProductoSubproducto}
                      setDisplayDialogProductoSubproducto={setDisplayDialogProductoSubproducto}
                      fetchData={fetchData}
                    />

                    <ConfirmDialog/>

                  </>
                )}
              </>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default MantenedorProductos;
